<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import LaisCard from 'dashboard/components-next/LaisCard.vue';
import PostSaleManagementDonutChart from './PostSaleManagementDonutChart.vue';

const props = defineProps({
  chart: { type: Object, required: true },
});
const emit = defineEmits(['viewFiltered']);
const { t } = useI18n();

const segments = computed(() =>
  props.chart.items.map(item => ({
    ...item,
    value: props.chart.values[item.key] || 0,
  }))
);
</script>

<template>
  <LaisCard :title="chart.title" density="flush">
    <PostSaleManagementDonutChart
      :aria-label="`${chart.title}: ${chart.total}`"
      :segments="segments"
    />

    <dl
      class="flex flex-wrap items-start justify-center gap-x-5 gap-y-3 px-5 pb-5"
    >
      <div
        v-for="item in chart.items"
        :key="item.key"
        class="min-w-14 text-center"
      >
        <dd class="text-xl font-semibold leading-6" :class="item.text">
          {{ chart.values[item.key] || 0 }}
        </dd>
        <dt class="mt-1 text-sm leading-5 text-lais-text-muted">
          {{ item.label }}
        </dt>
      </div>
    </dl>

    <template #footer>
      <div class="flex items-center justify-between gap-3">
        <p class="text-base font-normal text-lais-text-muted">
          {{ t('POST_SALE.MANAGEMENT.CHART.TOTAL', { count: chart.total }) }}
        </p>
        <details class="relative text-right">
          <summary
            class="flex cursor-pointer list-none items-center gap-1 text-sm font-medium text-lais-text-body"
          >
            <span class="i-lucide-ellipsis size-5" aria-hidden="true" />
            {{ t('POST_SALE.MANAGEMENT.CHART.FILTER_ACTION') }}
          </summary>
          <div
            class="absolute right-0 z-10 mt-2 w-52 rounded-lais border border-lais-border-soft bg-white p-2 text-left shadow-lais-pop"
          >
            <button
              v-for="item in chart.items"
              :key="item.key"
              type="button"
              class="block w-full rounded-lais-sm px-3 py-2 text-left text-sm text-lais-text-body hover:bg-lais-primary-50"
              @click="emit('viewFiltered', item.key)"
            >
              {{ item.menu }}
            </button>
          </div>
        </details>
      </div>
    </template>
  </LaisCard>
</template>
